import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";

export class RedovisningshanvisningValidation {
    static init(): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                message: { text: "Inmätningshandelssortiment måste anges" },
                model: () => null,
                name: "Inmatningshandelssortiment",
                required: true,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 5,
                message: { text: "Mottagningsplats måste anges" },
                model: () => null,
                name: "Mottagningsplats",
                expression: (value) => value !== null,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 6,
                message: { text: "Redovisningshänvisning måste anges" },
                model: () => null,
                name: "Redovisningshanvisning",
                expression: (value) => value !== null,
                triggerOnLoad: true
            }
        ]);
        return context;
    }
}
